import { Link } from "react-router-dom";
import type { Manhua } from "@/mocks/manhua";

export default function ManhuaCard({ item }: { item: Manhua }) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-xl bg-background-100 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[7/10] w-full overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 韩漫封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-medium text-background-50">
          {item.status}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-bold text-background-50">
          {item.rating}
        </span>
      </div>
      <div className="flex flex-col gap-1.5 p-3 md:p-4">
        <h3 className="heading-font text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-600">
          {item.category} · {item.latestChapter}
        </p>
        <div className="flex flex-wrap gap-1.5 pt-1">
          {item.tags.slice(0, 3).map((t) => (
            <span key={t} className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              {t}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}